/**
 * @generated SignedSource<<e026006ac24a53b6fe15f36158c09efe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateScormFileInput = {
  zipFileAssetId: string;
};
export type UploadScormFileDropzoneMutation$variables = {
  input: CreateScormFileInput;
};
export type UploadScormFileDropzoneMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type UploadScormFileDropzoneMutation = {
  response: UploadScormFileDropzoneMutation$data;
  variables: UploadScormFileDropzoneMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateScormFileResponse",
    "kind": "LinkedField",
    "name": "createScormFile",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ScormFile",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadScormFileDropzoneMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UploadScormFileDropzoneMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "015e8205713f61ae547813fe3e4a94fa",
    "id": null,
    "metadata": {},
    "name": "UploadScormFileDropzoneMutation",
    "operationKind": "mutation",
    "text": "mutation UploadScormFileDropzoneMutation(\n  $input: CreateScormFileInput!\n) {\n  response: createScormFile(input: $input) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4e486c0f0b96ee9a1ece8f92a1939a90";

export default node;
